import React, { useEffect, useState } from "react";
import { Button } from "antd";

import { getPrinters, printLabelItemInOrder } from "../../utils/Print";
import { Order } from "../../../types/model";

interface PrintLabelItemButtonProps {
  className?: string;
  style?: React.CSSProperties;
  size?: "small" | "middle" | "large";
  disabled?: boolean;
  handleError: (err: Error) => void;
  onPrint?: () => void;
  children: React.ReactNode;
  order: Order;
}

// Prints labels for all items that usually print labels (e.g. drinks).
const PrintLabelItemButton: React.FC<PrintLabelItemButtonProps> = ({
  className,
  style,
  size,
  disabled: disabledProp,
  handleError,
  onPrint,
  children,
  order,
}) => {
  const [loading, setLoading] = useState(false);
  const [printerUnavailable, setPrinterUnavailable] = useState(true);

  // Test to see if we can reach the print agent.
  useEffect(() => {
    getPrinters((_: any, err?: Error) => {
      if (err) {
        // Do nothing, do not enable the button.
      } else {
        setPrinterUnavailable(false);
      }
    });
  }, [order]);

  return (
    <Button
      type="primary"
      disabled={disabledProp || printerUnavailable}
      loading={loading}
      className={className}
      style={style}
      size="large"
      onClick={() => {
        setLoading(true);
        onPrint?.();
        printLabelItemInOrder(
          order,
          () => {
            setLoading(false);
          },
          (err) => {
            setLoading(false);
            handleError(err);
          }
        );
      }}
    >
      {children}
    </Button>
  );
};

export default PrintLabelItemButton;
